import styles from './index.less';
import { Mask } from 'antd-mobile';
import { FC, useState } from 'react';
import closeIconUrl from '@/assets/global/close_icon.png';
import checkUrl from '@/assets/bindHouse/check.png';
import { history } from '@umijs/max';
import BindHouse from '@/pages/Mine/My/components/BindHouse';

interface IAddHouseMaskDialogProps {
  visible: boolean;
  close: (value: boolean) => void;
  btnClick: () => void;
}

const AddHouseMaskDialog: FC<IAddHouseMaskDialogProps> = (props) => {
  const { visible, close } = props;
  const [bindHouseVisible, setBindHouseVisible] = useState<boolean>(false);
  
  const jumpToBindHouse = () => {
    setBindHouseVisible(true)
    // history.push('/house/bind');
  };
  return (
    <>
      <Mask visible={visible}>
        <div className={styles['mask']}>
          <div className={styles.content}>
            <p>绑定</p>
            <img src={checkUrl} alt="check" />
          </div>
          <div className={styles.text}>
            <p>请先绑定房间才能进行相关操作</p>
          </div>
          <div onClick={jumpToBindHouse} className={styles.btn}>
            立即绑定
          </div>
          <div className={styles['close-btn']}>
            <img
              src={closeIconUrl}
              alt={'close'}
              onClick={() => close(false)}
            />
          </div>
        </div>
        <BindHouse
          visible={bindHouseVisible}
          close={() => setBindHouseVisible(false)}
        />
      </Mask>
    </>
  );
};

export default AddHouseMaskDialog;
